<template>
    <v-dialog persistent
              @keydown.esc="_cancel"
              v-model="openDialog"
              :retain-focus="false"
              width="550" style=" min-height: 350px">
        <v-card  class="gradient-border-card d-flex flex-column">
            <v-card-title class="headline white--text" style="background: #11254d;background: linear-gradient(90deg,rgba(17, 37, 77, 1) 0%, rgba(17, 113, 112, 1) 50%, rgba(21, 168, 147, 1) 100%);">
                <h3 class="white--text">Επιβεβαίωση Ενέργειας</h3>
                <v-spacer></v-spacer>
                <v-icon @click="_cancel" color="white">close</v-icon>
            </v-card-title>

            <v-card-text style="background-color: #cecece" class="justify-center  pt-12">
                <v-row>
                    <v-col>
                        <h3 class="black--text">{{message}}</h3>
                    </v-col>
                </v-row>
            </v-card-text>


            <v-card-actions style="background-color: #cecece" class="justify-center pb-12 pt-6">
                <v-btn @click="_cancel" style="text-transform: none !important;"  rounded outlined color="primary">
                    Άκυρο
                    <v-icon size="25" color="primary"  right dark> mdi-close-circle </v-icon>
                </v-btn>

                <v-btn  @click="_confirm" style="text-transform: none !important;" rounded outlined color="#07575b">
                    Επιβεβαίωση
                    <v-icon size="25" color="#07575b"  right dark> mdi-checkbox-marked-circle </v-icon>
                </v-btn>
            </v-card-actions>

        </v-card>
    </v-dialog>
</template>

<script>
	export default {
		name: 'CustomWindowConfirm',
		data: () => ({
            openDialog:false,
			title: undefined,
			message: undefined, // Main text content

			resolvePromise: undefined,
			rejectPromise: undefined,
		}),

		methods: {
			show(opts = {}) {
				this.message = opts.message;

                // Once we set our config, we tell the popup modal to open
				this.openDialog = true;
                // Return promise so the caller can get results
				return new Promise((resolve, reject) => {
					this.resolvePromise = resolve;
					this.rejectPromise = reject
				})
			},

			_confirm() {
				this.openDialog = false;
				this.resolvePromise(true)
			},

			_cancel() {
				this.openDialog = false;
				this.resolvePromise(false)
// Or you can throw an error
// this.rejectPromise(new Error('User canceled the dialogue'))
			},
		},
	}
</script>


<style scoped>
    .gradient-border-card {
        border: 4px solid transparent;
        border-image: linear-gradient(
                90deg,
                rgba(17, 37, 77, 1) 0%,
                rgba(17, 113, 112, 1) 50%,
                rgba(21, 168, 147, 1) 100%
        );
        border-image-slice: 1;
        border-radius: 0!important;
    }
    .btns {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }

    .ok-btn {
        color: red;
        text-decoration: underline;
        line-height: 2.5rem;
        cursor: pointer;
    }

    .cancel-btn {
        padding: 0.5em 1em;
        background-color: #d5eae7;
        color: #35907f;
        border: 2px solid #0ec5a4;
        border-radius: 5px;
        font-weight: bold;
        font-size: 16px;
        text-transform: uppercase;
        cursor: pointer;
    }
</style>
